import { Badge, type BadgeTone } from '../ui/badge'

/**
 * The tone of each status a file import passes through. The statuses name the
 * import's lifecycle as the API reports it; the words on screen come from the
 * caller, so no app's wording lives here.
 */
const TONES: Record<string, BadgeTone> = {
  validating: 'info',
  applying: 'info',
  ready: 'signal',
  invalid: 'danger',
  failed: 'danger',
  stale: 'warning',
  applied: 'success',
  cancelled: 'neutral',
  expired: 'neutral',
}

export function importStatusTone(status: string): BadgeTone {
  return TONES[status] ?? 'neutral'
}

/** An import's status: the tone comes from its status, the text from `label`. */
export function ImportStatusBadge({
  status,
  label,
  'data-testid': testId,
}: {
  status: string
  label: string
  'data-testid'?: string
}) {
  return (
    <Badge tone={importStatusTone(status)} data-testid={testId}>
      {label}
    </Badge>
  )
}
